import type { ReactNode } from 'react';
import { Col, FormGroup, Row } from '@ksyos/design-system';
import { StyledBorderAndPadding } from '@frontend/components/elements/common';
import { TooV1ProcedureReadOdOsDataField } from './TooV1ProcedureReadOdOsDataField';
import { TooV1ProcedureReadOdOsLabel } from './TooV1ProcedureReadOdOsLabel';

interface ITooV1ProcedureOdOsRead {
    children?: ReactNode[];
    dataOd: string | null;
    dataOs: string | null;
    label: string;
    units?: string;
}

export function TooV1ProcedureReadOdOs({ children, dataOd, dataOs, label, units }: ITooV1ProcedureOdOsRead) {
    return (
        <FormGroup label={label}>
            <Row columnGap={[2, 4, 6]}>
                <Col span={[12, 6, null, null, 4]}>
                    <StyledBorderAndPadding>
                        <TooV1ProcedureReadOdOsLabel side="OD" />
                        <TooV1ProcedureReadOdOsDataField
                            data={dataOd}
                            units={units}
                        />
                        {children ? children[0] : null}
                    </StyledBorderAndPadding>
                </Col>
                <Col span={[12, 6, null, null, 4]}>
                    <StyledBorderAndPadding>
                        <TooV1ProcedureReadOdOsLabel side="OS" />
                        <TooV1ProcedureReadOdOsDataField
                            data={dataOs}
                            units={units}
                        />
                        {children ? children[1] : null}
                    </StyledBorderAndPadding>
                </Col>
            </Row>
        </FormGroup>
    );
}
